// Onboarding Page Component
// ==========================
// Entry point for the onboarding flow. Auth/routing is handled by the router
// (ProtectedRoute). This component simply renders the chat-based onboarding UI.

import React from 'react';
import OnboardingChat from './OnboardingChat';

const OnboardingPage: React.FC = () => {
  return <OnboardingChat />;
};

export default OnboardingPage;
